import { render, staticRenderFns } from "./ChapterForm.vue?vue&type=template&id=1596b570&scoped=true&"
import script from "./ChapterForm.vue?vue&type=script&lang=js&"
export * from "./ChapterForm.vue?vue&type=script&lang=js&"
import style0 from "./ChapterForm.vue?vue&type=style&index=0&id=1596b570&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1596b570",
  null
  
)

export default component.exports